import {makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  btn: {
    '& .MuiButton-label': {
      display: 'flex',
      gap: 8,
      fontSize: '1rem',
      textTransform: 'initial',
      letterSpacing: 'normal',
      marginRight: 8,
    },
    '& .MuiButton-startIcon': {
      margin: '0 0 0 4px',
    },
    '&.MuiButton-containedPrimary': {
      minWidth: 152,
      backgroundColor: theme.palette.amber.middle,
      color: theme.palette.black90,
      padding: '12px 24px',
      animationDuration: '100ms',
      animationTimingFunction: 'ease-in',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: theme.palette.amber.light,
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.16)',
      },
      '& .MuiButton-label': {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '24px',
        textAlign: 'center',
        marginRight: 0,
      },
      '&.MuiButton-contained.Mui-disabled': {
        backgroundColor: theme.palette.customGrey.light,
        color: theme.palette.white,
      },
    },
    '&.MuiButton-containedSecondary': {
      minWidth: 152,
      backgroundColor: theme.palette.white,
      color: theme.palette.black90,
      border: `3px solid ${theme.palette.amber.light}`,
      padding: '9px 0',
      animationDuration: '100ms',
      animationTimingFunction: 'ease-in',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: theme.palette.warning.light,
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.16)',
      },
      '& .MuiButton-label': {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '24px',
        textAlign: 'center',
        marginRight: 0,
      },
    },
  },
}))

export default useStyles
